import React, { Component } from 'react'
import { PropTypes } from 'prop-types'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { withRouter } from 'react-router'
import { withStyles, Typography, Grid, Button } from '@material-ui/core'
import get from 'lodash.get'
import dialer from '../images/svg/dialer.svg'
import MenuBar from '../components/header/MenuBar'
import Footer from '../components/Footer'
import Map from '../components/map/Map'
import MapFranchisee from '../components/map/MapFranchisee'
import FlashMessage from '../components/FlashMessage'
import Properties from '../components/Properties'
import DetailsModal from '../components/DetailsModal'
import NetworkIssue from '../components/NetworkIssue'
import * as actions from '../actions'
import * as utils from '../utils'
import * as types from '../constants'
import CloseIcon from '@material-ui/icons/Close'
import { Map as MapList } from 'immutable'

const adCouncilFields = ['id', 'name', 'subdomain', 'description', 'location', 'profileImageUrl', 'bannerImageUrl', 'phone'].join()

const styles = theme => ({
  container: {
    display: 'grid',
    gridTemplateColumns: 'repeat(12, 1fr)',
    gridGap: `${theme.spacing.unit * 3}px`,
  },
  flexColumn: {
    display: 'flex',
    flexDirection: 'column',
  },
  paper: {
    padding: theme.spacing.unit,
    textAlign: 'center',
    color: theme.palette.text.secondary,
    whiteSpace: 'nowrap',
    marginBottom: theme.spacing.unit,
  },
  franchiseePicParent: { paddingRight: '15px', marginTop: '4em' },
  divider: {
    margin: `${theme.spacing.unit * 2}px 0`,
  },
  dialerPic: { margin: '0px 6px -1px 0' },
  messageFranchiseeForm: {
    height: '323px',
    padding: '20px 15px',
    backgroundColor: '#ffd200',
    width: '320px',
    float: 'right',
  },
  bannerDiv: {
    height: '25vw',
    backgroundSize: 'contain',
    backgroundPosition: 'center',
    backgroundRepeat: 'no-repeat',
    flexBasis: 'auto',
    [theme.breakpoints.down('sm')]: {
      backgroundSize: 'cover',
      backgroundPosition: 'center center',
    },
    '& $messageFranchiseeForm': {
      [theme.breakpoints.down('776')]: {
        display: 'none !important',
      },
    },
  },
  mobileForm: {
    display: 'flex',
    '& $messageFranchiseeForm': {
      width: '100%',
      margin: '32px 0 0 0',
      display: 'block',
      [theme.breakpoints.up('775')]: {
        display: 'none',
      },
      [theme.breakpoints.down('xs')]: {
        margin: '0px 0 24px 0',
      },
    },
  },
  mapGrid: {
    margin: '0px 0px 32px 0px',
    [theme.breakpoints.down('xs')]: {
      display: 'none',
    },
  },
  mobileMapGrid: {
    margin: '0 0 20px 0',
    [theme.breakpoints.up('768')]: {
      display: 'none',
    },
  },
  inputElement: {
    fontSize: '15px',
    lineHeight: '1.33',
    color: '#404552',
    height: '44px',
    borderRadius: '4px',
    backgroundColor: '#ffffff',
    border: 'solid 1px rgba(182, 182, 182, 0.25)',
    marginBottom: '12px',
    padding: '12px',
    boxSizing: 'border-box',
    '&:focus': {
      boxShadow: 'none',
      border: 'solid 1px rgba(182, 182, 182, 0.25)',
    },
  },
  textField: {
    fontSize: '15px',
    lineHeight: '1.33',
    color: '#404552',
    height: '108px',
    borderRadius: '4px',
    backgroundColor: '#ffffff',
    border: 'solid 1px rgba(182, 182, 182, 0.25)',
    marginBottom: '12px',
    padding: '12px',
    boxSizing: 'border-box',
  },
  bootstrapRoot: {
    padding: 0,
    'label + &': {
      marginTop: theme.spacing.unit * 3,
    },
  },
  bootstrapInput: {
    fontSize: '15px',
    lineHeight: '1.33',
    color: '#404552',
    height: '44px',
    borderRadius: '4px',
    backgroundColor: '#ffffff',
    border: 'solid 1px rgba(182, 182, 182, 0.25)',
    marginBottom: '0px',
    padding: '12px',
    boxSizing: 'border-box',
    '&:focus': {
      boxShadow: 'none',
      border: 'solid 1px rgba(182, 182, 182, 0.25)',
    },
  },
  heading2: {
    fontSize: '28px',
    fontWeight: '500',
    letterSpacing: '-0.4px',
    color: '#2d3447',
    margin: '0',
  },
  mainContent: {
    padding: '0',
    position: 'relative',
    top: '-50px',
    width: '1220px',
    margin: 'auto',
    [theme.breakpoints.down('1220')]: {
      width: '100%',
      padding: '0 15px 0',
    },
    [theme.breakpoints.down('sm')]: {
      margin: '0 0px',
    },
    [theme.breakpoints.down('xs')]: {
      top: '-25px',
    },
  },
  overviewDiv: {
    '& h2': {
      fontSize: '25px',
      fontWeight: '500',
      color: '#2d3447',
      margin: '10px 0 12px',
      [theme.breakpoints.down('xs')]: {
        fontSize: '16px',
        margin: '5px 0',
      },
    },
    '& contDetails': {
      display: 'flex',
      margin: '21px 0 0',
      fontSize: '14px',
      color: '#727272',
      lineHeight: '1.5',
    },
  },
  description: {
    textAlign: 'justify',
    fontSize: '16px',
    lineHeight: '1.5',
    color: '#333645',
    margin: '28px 0px 32px 0px',
  },
  franchiseeListings: {
    maxWidth: '100%',
    margin: '0 auto',
    '& h2': {
      margin: '20px 0 0',
    },
    [theme.breakpoints.down('1047')]: {
      maxWidth: '600px',
    },
    [theme.breakpoints.down('737')]: {
      maxWidth: '290px',
    },
  },
  cardGrid: {
    width: '290px',
    margin: '0 15px',
  },
  franchiseePic: {
    width: '120px',
    minHeight: '120px',
    border: 'solid 3px #f9f9f9',
    borderRadius: '4px',
    boxShadow: '0 8px 12px 0 rgba(0, 0, 0, 0.21)',
    backgroundColor: '#e5f8f7',
    [theme.breakpoints.down('xs')]: {
      width: '52px',
      minHeight: '52px',
    },
  },
  contDetails: {
    display: 'flex',
    margin: '21px 0 0',
    fontSize: '14px',
    color: '#727272',
    lineHeight: '1.5',
    [theme.breakpoints.down('xs')]: {
      fontSize: '13px',
      lineHeight: '1.38',
      marginTop: '10px',
    },
    '& p': {
      margin: '0',
      display: 'flex',
      [theme.breakpoints.down('xs')]: {
        flexDirection: 'column',
      },
    },
    '& span:first-child': {
      maxWidth: '155px',
      display: 'inline-block',
      margin: '0 48px 0 0',
    },
    '& span:last-child': {
      margin: '0',
      [theme.breakpoints.down('xs')]: {
        margin: '7px 0 0 0',
      },
    },
    '& span:empty': {
      display: 'none',
    },
  },
  card: {
    boxShadow: '0 3px 11px 0 rgba(78, 78, 78, 0.17)',
    margin: '0 0 15px',
    display: 'flex',
  },
  cardContent: {
    '& h2': {
      fontSize: '18px',
      fontWeight: '500',
      color: '#231f20',
      margin: '0 0 6px',
    },
    '& h4': {
      fontSize: '14px',
      fontWeight: '500',
      color: '#00bcb5',
      margin: '0 0 6px',
      textTransform: 'uppercase',
    },
    '& p': {
      fontSize: '14px',
      fontWeight: '400',
      color: '#838383',
      margin: '0',
      display: 'flex',
      alignItems: 'center',
    },
  },
  mobileMapWrapper: {
    position: 'fixed',
    top: 0,
    right: 0,
    bottom: 0,
    left: 0,
    zIndex: 1200,
    maxWidth: '100%',
    maxHeight: '100vh',
  },
  viewMapBtn: {
    width: '100%',
    height: '46px',
    borderRadius: '0px',
    backgroundColor: '#ffd200',
    fontSize: '16px',
    fontWeight: '500',
    lineHeight: '1.06',
    textAlign: 'center',
    color: '#000000',
    textTransform: 'uppercase',
    '&:hover': {
      opacity: '1',
      backgroundColor: '#ffd200',
    },
  },
  mapAndListingWrapper: {
    padding: theme.spacing.unit * 2,
  },
  propertyWrapper: {
    '&>div div': {
      justifyContent: 'center',
    },
    '&>div>div>h2': {
      marginTop: 0,
    },
  },
  dealerName: {
    marginTop: '4em',
  },
})

const MOBILE_BREAKPOINT = process.env.REACT_APP_TABLET_BREAKPOINT

class AdcouncilPage extends Component {
  static propTypes = {
    actions: PropTypes.object.isRequired,
    searchLocation: PropTypes.object,
    classes: PropTypes.object,
    history: PropTypes.object,
  }

  constructor(props) {
    super(props)

    this.state = {
      showDetail: false,
      id: 0,
      showMap: false,
      pageFound: true,
      width: window.innerWidth,
    }
  }

  componentDidUpdate(prevProps) {
    const prevID = get(prevProps, 'match.params.propertyID', 0)
    const currID = get(this.props, 'match.params.propertyID', 0)

    if (currID > 0 && prevID !== currID) {
      this.setState({
        showDetail: true,
      })
    }
    if (this.props.statusUpdate !== prevProps.statusUpdate) {
      this.updateProperties()
    }
  }

  componentDidMount() {
    this.updateProperties()
  }

  updateProperties() {
    const {
      actions,
      match: { params },
    } = this.props

    utils.trackPage(window.location.href)

    actions.fetchSubDomain(data => {
      // not a franchisee or adcouncil so will navigate to root page
      // FIXME: doesn't make any sense to get here at all
      if (!data) {
        this.setState({ pageFound: false })
        return
      }

      this.setState({
        id: get(data, 'record_id', 0), // FIXME: what does 0 mean?
      })

      if (data.record_type === 'Franchisee') {
        actions.fetchFranchisee({
          query: `query {
            franchisee(id: ${data.record_id}) {
              ${utils.franchiseeFields},
              properties { ${utils.propertyFields} }
            }
          }`,
        })
      } else {
        actions
          .fetchAdCouncil({
            query: `query { adCouncil(id: ${data.record_id}) { ${adCouncilFields} } }`,
          })
          .then(res => {
            this.fetchPropertiesNoMap(MapList(res))
          })
      }
    })

    if (params.propertyID) {
      this.setState({
        showDetail: true,
      })
    }
  }
  componentWillMount() {
    window.addEventListener('resize', this.handleResize)
  }

  componentWillUnMount() {
    window.removeEventListener('resize', this.handleResize)
  }

  toggleDetail() {
    const { showDetail } = this.state
    this.setState({
      showDetail: !showDetail,
    })
    if (showDetail) {
      this.props.history.push(`${types.ROUTES_PATH.HOME}`)
    }
  }

  toggleMap() {
    this.setState(state => ({ showMap: !state.showMap }))
  }

  handleResize = () => {
    this.setState({ width: window.innerWidth })
  }

  fetchPropertiesNoMap = location => {
    const { width } = this.state
    const isResponsive = width < process.env.REACT_APP_TABLET_BREAKPOINT
    if (isResponsive) {
      const { actions, viewPort } = this.props
      const safeBounds = utils.createSafeBounds({ viewPort: viewPort, loc: location })
      const geoRect = {
        w: get(safeBounds, 'sw.lng', parseFloat(process.env.REACT_APP_DEFAULT_LNG)),
        e: get(safeBounds, 'ne.lng', parseFloat(process.env.REACT_APP_DEFAULT_LNG)),
        n: get(safeBounds, 'ne.lat', parseFloat(process.env.REACT_APP_DEFAULT_LAT)),
        s: get(safeBounds, 'sw.lat', parseFloat(process.env.REACT_APP_DEFAULT_LAT)),
      }
      actions.fetchPropertiesFromRect(geoRect)
    }
  }

  propertyRemoved = id => {
    setTimeout(() => {
      this.child.propFlagged()
    }, 3000)
  }

  render() {
    const { id, showDetail, showMap, pageFound, width } = this.state

    // FIXME: render + cDM -> fetch -> setState -> render = irrelevant content "flash"
    // FIXME: this is a global issue
    if (!pageFound) {
      return <NetworkIssue />
    }

    const {
      classes,
      adCFrDetails: { bannerImageUrl, profileImageUrl, name, phone, description, address, city, state, zip, location, lat, lon },
      searchLocation,
      match: { params },
      viewPort,
      pageType,
      properties,
    } = this.props

    const center = {
      lat: parseFloat(searchLocation.get('lat') || process.env.REACT_APP_DEFAULT_LAT),
      lng: parseFloat(searchLocation.get('lng') || process.env.REACT_APP_DEFAULT_LNG),
    }

    const isMobileView = width < MOBILE_BREAKPOINT && showMap
    let filterProps = utils.filteredProperties(properties)
    return (
      <Grid container className={classes.flexColumn}>
        {/* map for mobile-view below */}
        {isMobileView && (
          <div className={`${classes.mobileMapWrapper}`}>
            <div className="mapCloseBtn">
              <CloseIcon onClick={() => this.toggleMap()} />
            </div>
            {pageType !== 'franchisee' ? (
              <Map center={center} viewPort={viewPort} onMarkerClick={() => this.toggleDetail()} initialZoom={7} id={id} pageType={'AdCFr'} mobile />
            ) : (
              <MapFranchisee
                onRef={ref => (this.child = ref)}
                viewPort={viewPort}
                onMarkerClick={() => this.toggleDetail()}
                initialZoom={7}
                id={id}
                pageType={'AdCFr'}
                mobile
              />
            )}
          </div>
        )}
        {/* map for mobile-view above */}
        <Grid item xs={12}>
          <MenuBar hidePremium={true} withSearchBox />
        </Grid>
        {bannerImageUrl && <Grid item xs={12} className={classes.bannerDiv} style={{ backgroundImage: ` url(${bannerImageUrl})` }} />}
        {/* banner section above */}
        <div className={classes.mainContent}>
          <Grid item xs={12} md={12} className={classes.overviewDiv}>
            <div style={{ display: 'block' }}>
              {profileImageUrl && (
                <div className={classes.franchiseePicParent}>
                  <img src={profileImageUrl} alt={'franchisee_pic'} className={classes.franchiseePic} />
                </div>
              )}
              <div className={classes.dealerName}>
                <h2 className={classes.heading2}>{name} Wholesale Properties</h2>
                <div className={classes.contDetails}>
                  <p>
                    <span>{[address, city, state, zip].filter(x => !!x).join(', ')}</span>
                    {phone && (
                      <span>
                        <img src={dialer} alt={'dialer'} className={classes.dialerPic} />
                        Phone {phone}
                      </span>
                    )}
                  </p>
                </div>
              </div>
            </div>
            <Typography className={classes.description}>{description}</Typography>
          </Grid>
          {/* overview section above */}
          {/* messageFranchiseeForm for mobile view above */}
          {(location || (lat && lon) || pageType === 'franchisee') && (
            <Grid container className={classes.mapAndListingWrapper}>
              {width >= MOBILE_BREAKPOINT &&
                (pageType !== 'franchisee' ? (
                  <Grid item xs={12} sm={8} className={classes.mapGrid}>
                    <Map center={center} viewPort={viewPort} onMarkerClick={() => this.toggleDetail()} initialZoom={7} id={id} pageType={'AdCFr'} />
                  </Grid>
                ) : filterProps.size > 0 ? (
                  <Grid item xs={12} sm={8} className={classes.mapGrid}>
                    <MapFranchisee
                      onRef={ref => (this.child = ref)}
                      viewPort={viewPort}
                      onMarkerClick={() => this.toggleDetail()}
                      initialZoom={7}
                      id={id}
                      pageType={'AdCFr'}
                    />
                  </Grid>
                ) : (
                  ''
                ))}
              {pageType !== 'franchisee' ? (
                <Grid item className={classes.mobileMapGrid}>
                  <Button className={classes.viewMapBtn} onClick={() => this.toggleMap()}>
                    view on map
                  </Button>
                </Grid>
              ) : filterProps.size > 0 ? (
                <Grid item className={classes.mobileMapGrid}>
                  <Button className={classes.viewMapBtn} onClick={() => this.toggleMap()}>
                    view on map
                  </Button>
                </Grid>
              ) : (
                ''
              )}

              {/* above is map section */}
              <Grid item xs={12} sm={4}>
                <Grid container className={`${classes.similarProps} ${classes.franchiseeListings}`}>
                  <Properties onSelect={() => this.toggleDetail()} isAdcFr className={classes.propertyWrapper} />
                  <DetailsModal
                    propertyRemoved={id => this.propertyRemoved(id)}
                    open={showDetail}
                    onClose={() => this.toggleDetail()}
                    propertyId={params.propertyID}
                  />
                </Grid>
              </Grid>
            </Grid>
          )}
          {/* above is listing / card */}
        </div>
        <Footer />

        <FlashMessage />
      </Grid>
    )
  }
}

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators(actions, dispatch),
  }
}

function mapStateToProps(state) {
  return {
    adCFrDetails: state.adcouncil,
    searchLocation: state.properties.get('loc'),
    properties: state.properties.get('data'),
    similarProperties: state.similarProperties.get('data'),
    subdomain: state.subdomain.data,
    viewPort: state.properties.get('viewPort'),
    pageType: state.common.get('pageType'),
    statusUpdate: state.user.statusUpdate,
  }
}

export default withRouter(
  withStyles(styles)(
    connect(
      mapStateToProps,
      mapDispatchToProps
    )(AdcouncilPage)
  )
)



// WEBPACK FOOTER //
// ./src/containers/AdCouncilFranchiseePage.js